<!-- 项目文件 -->
<template>
    <div>
        <div class="w100p pt50 ">
            <div class="w1200 mauto">
                <div class="textc mt20 mb20">
                    <p class="fs36 c333 disinblock posre">
                        <span class="border-bottom1">
                            学车资讯
                        </span>
                    </p>
                </div>
                <div class="w100p overhidden pb20">
                    <div class="w50p floatl disinblock  bgf6 pt20 pb20 pl40 pr40">
                        <div class=" pb15 mt15"  v-for="(item,index) in news.slice(0,3)" :key="index" :class="{'border2':index !=2 }">
                            <p class="mt10 mb10">
                                <span class="disinblock bg1f8 w18 h18 bradius4 cfff fs12 textc"> {{index+1}} </span>
                                <span class="disinblock fs16 c333 fbold ml16"> {{item.title}} </span>
                            </p>
                            <p class="c999 fs14 mb8 mt8">
                                {{item.update_time | formatDate}}
                            </p>
                            <p class="alit mt10 mb10">
                                <span class="fs15 c333 disinblock over_1 w80p" > {{item.text1}} </span>
                           
                                <!-- @click="TonewsList(cityID)" -->
                                <span class="fs16 c1f8 ml15 disinblock cursor"   @click="Todetail(item.id,cityID)"> 
                                     【详情>】 
                                </span>
                            </p>
                        </div>
                    </div>
                    <div class="w40p floatr disinblock posre">
                        <swiper :options="swiperOption" class="posab zindex999 w100p h400 left0 top0 zindex-1 zoom1 indexbg">
                            <swiper-slide v-for="(item,index) in banner" :key="index"  class="w100p h100p ">
                                <img class="w100p h100p cursor" @click="Tobanner(index)" :src="item.image || 'https://365taoke.oss-cn-hangzhou.aliyuncs.com/card/20200429/img1.png'">
                            </swiper-slide>
                        </swiper>
                    </div>
                </div>
                <div class="textc mt20 mb20">
                    <span @click="TonewsList(cityID)" class="disinblock fs18 bradius8 border1f8 c1f8 pt10 pb10 pl45 pr45 cursor" >查看更多>>  </span>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    import $ from "jquery";
    export default {
        props: ['news', 'banner', 'cityID'],
        data() {
            return {

                swiperOption: { //swiper3
                    autoplayDisableOnInteraction: false,
                    autoplay: {
                        autoplay: 2000,
                    },
                    autoplay: 2000,
                    speed: 2000,
                    slidesPerView: 1,
                    centeredSlides: false,
                    // slidesPerView: 'auto',
                    centeredSlides: true,
                    spaceBetween: 10,
                    observer: true,
                    observeParents: true,
                    loop: true,
                }

            };
        },
        filters: {
            formatDate(value) {
                var d = new Date(parseInt(value) * 1000);
                return (d.getFullYear()) + '-' + (d.getMonth() + 1 > 9 ? d.getMonth() + 1 : '0' + (d.getMonth() + 1)) + '-' +
                    (d.getDate() > 9 ? d.getDate() : '0' + d.getDate());
            }
        },
        methods: {
            Todetail(id, cityID) {
                let that = this;
                that.$router.push({
                    path: "/Newsdetail",
                    query: {
                        news_id: id,
                        cityid: cityID
                    }
                });
                //window.open(Todetail.href, '_blank');
            },
            TonewsList(cityID) {
                let that = this;
                that.$router.push({
                    path: "/News",
                    query: {
                        // news_id: id,
                        cityid: cityID
                    }
                });
                // window.open(TonewsList.href, '_blank');
            },
            Tobanner(id) {
                let that = this;
                that.$router.push({
                    path: "/Bannerdetail",
                    query: {
                        // news_id: id,
                        BanerId: id
                    }
                });
            }
        },
        created() {

        },
        mounted() {
            // this.mySwiper.slideTo(0, 1000, true)

            var mySwiper = new Swiper('.swiper-container', {
                onAutoplay: function(swiper) {
                    //alert('自动切换了;');
                }
            })
        },
    }
</script>
<style scoped>
    .change /deep/ .swiper-pagination-bullet {
        width: 12px;
        height: 12px;
    }
</style>